var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportSel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_1352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 3.50198H14.1231L11.3184 0.747253V3.36227C11.3184 3.43927 11.3811 3.50198 11.4583 3.50198Z",
    fill: "url(#paint0_linear_10_1352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 4.38089C10.8967 4.38089 10.4396 3.92395 10.4396 3.36227V0.492188H3.1319C2.22772 0.492188 1.49219 1.22772 1.49219 2.1319V13.8525C1.49219 14.7567 2.22772 15.4922 3.1319 15.4922H12.7431C13.6474 15.4922 14.3828 14.7567 14.3828 13.8525V4.38089H11.4583ZM10.4538 11.8594H4.79358C4.55087 11.8594 4.35413 11.6626 4.35413 11.4199C4.35413 11.1772 4.55087 10.9805 4.79358 10.9805H10.4538C10.6966 10.9805 10.8933 11.1772 10.8933 11.4199C10.8933 11.6626 10.6966 11.8594 10.4538 11.8594ZM4.35413 9.66211C4.35413 9.4194 4.55087 9.22266 4.79358 9.22266H9.84454C10.0873 9.22266 10.284 9.4194 10.284 9.66211C10.284 9.90482 10.0872 10.1016 9.84454 10.1016H4.79358C4.55087 10.1016 4.35413 9.90482 4.35413 9.66211ZM10.9882 8.34375H4.79358C4.55087 8.34375 4.35413 8.147 4.35413 7.9043C4.35413 7.66159 4.55087 7.46484 4.79358 7.46484H10.9882C11.2309 7.46484 11.4277 7.66159 11.4277 7.9043C11.4277 8.147 11.2309 8.34375 10.9882 8.34375Z",
    fill: "url(#paint1_linear_10_1352)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_1352",
    x1: 12.7207,
    y1: 0.747253,
    x2: 12.7207,
    y2: 3.50198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_1352",
    x1: 7.9375,
    y1: 0.492187,
    x2: 7.9375,
    y2: 15.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_1352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportSel);
export default __webpack_public_path__ + "static/media/reportSel.ec1aaeccecb9800e59a65d22411c2deb.svg";
export { ForwardRef as ReactComponent };